import { BehaviorSubject } from "rxjs";
import * as Visibility from "visibilityjs";
import { blur$, focus$ } from "../../events/eventsBrowser";
import { StateWindowVisibility } from "./StateWindowVisibility";
var UtilWindowVisibility = /** @class */ (function () {
    function UtilWindowVisibility() {
        var _this = this;
        this.visibility$ = new BehaviorSubject(StateWindowVisibility.Visible);
        this.onVisibilityChange = function (event, state) {
            _this.visibility$.next(state);
        };
        if (Visibility.isSupported()) {
            Visibility.change(this.onVisibilityChange);
        }
        else {
            blur$.subscribe(function () { return _this.visibility$.next(StateWindowVisibility.Hidden); });
            focus$.subscribe(function () { return _this.visibility$.next(StateWindowVisibility.Visible); });
        }
    }
    return UtilWindowVisibility;
}());
export var utilWindowVisibility = new UtilWindowVisibility();



//////////////////
// WEBPACK FOOTER
// ./src/utils/window-visibility/utilWindowVisibility.ts
// module id = 1679
// module chunks = 3